<template>
  <Form :model="formData"
        :rules="rules"
        class="login__form"
        ref="form">
    <FormItem prop="username">
      <Input type="text"
             @keyup.enter.native="handleSubmit"
             placeholder="请输入用户名/手机号/邮箱"
             element-id="username"
             v-model.trim="formData.username" />
    </FormItem>
    <FormItem prop="password">
      <Input type="password"
             placeholder="请输入密码"
             @keyup.enter.native="handleSubmit"
             password
             element-id="password"
             v-model="formData.password" />
    </FormItem>
    <FormItem prop="validateCode" class="login__valid-form-item">
      <Input placeholder="请输入验证码"
             @keyup.enter.native="handleSubmit"
             element-id="usernameValidateCode"
             v-model="formData.validateCode" />
      <div class="login__valid-img">
        <img :src="validationCodeUrl"
             alt="验证码"/>
        <p @click="getValidationCode">看不清楚? 换一张</p>
      </div>
    </FormItem>
    <Button @click="handleSubmit"
            long
            :disabled="isSubmitDisabled"
            type="primary"
            :loading="loading"
            shape="circle"
            id="loginByUsername">登录</Button>
  </Form>
</template>

<script>
import { loginByUsername } from '@/api/user/user';
import validationCode from '@/mixins/user/validationCode';
import login from '@/mixins/user/login';
import { passwordToMd5 } from '@/utils/util';

export default {
  name: 'LoginByUsername',
  mixins: [validationCode, login],
  data() {
    return {
      formData: {},
      rules: {},
      loading: false,
    };
  },
  computed: {
    isSubmitDisabled() {
      return !(this.formData.username
        && this.formData.password
        && this.formData.validateCode);
    },
  },
  methods: {
    async handleSubmit() {
      if (this.loading || this.isSubmitDisabled) {
        return false;
      }
      const valid = await this.$refs.form.validate();
      if (valid) {
        const { username, password, validateCode } = this.formData;
        this.loading = true;
        const res = await loginByUsername({
          username,
          password: passwordToMd5(password),
          validation_code: validateCode,
        });
        this.login(res);
        this.loading = false;
      }
      return false;
    },
  },
};
</script>
